import { createSlice } from "@reduxjs/toolkit";

const initialLeadTypeState = {
  filterString: "-1",
  defaultValue: null,
  filterCount: 0,
  dueWithinDays: 0,
  filterDefinitions: [],
};

const initialFilterState = {
  "0": { ...initialLeadTypeState },
  "1": { ...initialLeadTypeState },
  "-1": { ...initialLeadTypeState },
  "2": { ...initialLeadTypeState },
};

const filterSlice = createSlice({
  name: "filter",
  initialState: initialFilterState,
  reducers: {
    setLeadTypeFilter: (state, action) => {
      const { leadType, filterString, defaultValue, filterCount, dueWithinDays, filterDefinitions } = action.payload;
      state[leadType] = {
        filterString,
        defaultValue,
        filterCount: filterCount || 0,
        dueWithinDays: dueWithinDays || 0,
        filterDefinitions: filterDefinitions || state[leadType].filterDefinitions,
      };
    },
    setFilterDefinitions: (state, action) => {
      const { leadType, filterDefinitions } = action.payload;
      state[leadType].filterDefinitions = filterDefinitions;
    },
    clearLeadTypeFilter: (state, action) => {
      const { leadType } = action.payload;
      state[leadType] = { ...initialLeadTypeState };
    },
  },
});

export const { setLeadTypeFilter, setFilterDefinitions, clearLeadTypeFilter } = filterSlice.actions;
export default filterSlice.reducer;

